import { SiteCopy } from "../copy";
import { CONTACT_HREF } from "../links";
import {
  Asks,
  EmployerCards,
  EmployerProof,
  EmployerRollout,
  EmployerStats,
  HeadcountCalc,
  HrDash,
  WebinarStrip,
} from "../widgets/employers";
import { usePageTitle } from "./usePageTitle";
import { PageFaq } from "../widgets/PageFaq";

const CALC_ID = "calcwrap2";

/** For employers (the prototype's `data-s="employers"`). */
export function EmployersPage() {
  usePageTitle("For employers");
  return (
    <div className="spage on" data-s="employers">
      <header className="hero" style={{ paddingBottom: 0 }}>
        <div className="wrap">
          <SiteCopy as="h1" k="employers.h1" />
          <SiteCopy as="p" className="lede" k="employers.lede" />
          <div className="cta" style={{ marginTop: 28 }}>
            <a className="sbtn p big" href={CONTACT_HREF}>
              <SiteCopy k="cta.employers" />
            </a>
          </div>
        </div>
      </header>
      <section className="band tight bWarm">
        <div className="wrap">
          <div className="shead rv" style={{ marginBottom: 18 }}>
            <SiteCopy as="p" className="mono" k="employers.cost.eyebrow" />
            <SiteCopy as="h2" k="emp.costh2" />
          </div>
          <EmployerStats />
        </div>
      </section>

      <section className="band">
        <div className="wrap">
          <div className="shead rv">
            <SiteCopy as="p" className="mono" k="employers.hr.eyebrow" />
            <SiteCopy as="h2" k="employers.hr.h2" />
            <SiteCopy as="p" k="employers.hr.p" />
          </div>
          <HrDash />
          <p className="hrpriv rv d2">
            <b>What is never in it:</b> <SiteCopy k="employers.hr.priv" />
          </p>
        </div>
      </section>

      <section className="band bWhite">
        <div className="wrap">
          <div className="shead rv">
            <SiteCopy as="p" className="mono" k="employers.proof.eyebrow" />
            <SiteCopy as="h2" k="employers.proof.h2" />
            <SiteCopy as="p" k="employers.proof.p" />
          </div>
          <EmployerProof />
          <p className="railhint">Swipe</p>
          <SiteCopy as="p" className="enote rv d2" k="employers.proof.note" />
          <SiteCopy as="p" className="emeth rv d2" k="employers.proof.method" />
        </div>
      </section>

      <section className="band">
        <div className="wrap">
          <EmployerCards />
          <p className="railhint">Swipe</p>
        </div>
      </section>

      <section className="band bWhite">
        <div className="wrap">
          <div className="shead rv">
            <SiteCopy as="p" className="mono" k="employers.roll.eyebrow" />
            <SiteCopy as="h2" k="employers.roll.h2" />
          </div>
          <EmployerRollout />
          <div className="ctarow rv d2">
            <a className="sbtn p big" href={CONTACT_HREF}>
              <SiteCopy k="cta.employers" />
            </a>
            <span>We start with twenty people and a month.</span>
          </div>
        </div>
      </section>

      <section className="band tight">
        <div className="wrap">
          <div className="shead rv" style={{ marginBottom: 18 }}>
            <SiteCopy as="p" className="mono" k="emp.calc.eyebrow" />
            <SiteCopy as="h2" k="emp.calc.h2" />
            <SiteCopy as="p" k="emp.calc.p" />
          </div>
          <HeadcountCalc id={CALC_ID} />
        </div>
      </section>

      <WebinarStrip />

      <section className="band bWhite">
        <div className="wrap">
          <div className="shead rv">
            <SiteCopy as="p" className="mono" k="emp.asks.eyebrow" />
            <SiteCopy as="h2" k="emp.asks.h2" />
          </div>
          <Asks calcId={CALC_ID} />
        </div>
      </section>

      <PageFaq page="employers" />
      <section className="endcta">
        <div className="wrap">
          <SiteCopy as="h2" k="employers.end.h2" />
          <SiteCopy as="p" k="employers.end.p" />
          <div className="cta">
            <a className="sbtn p big" href={CONTACT_HREF}>
              <SiteCopy k="employers.end.cta" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
